/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: CA
 *| (C) Copyright IBM Corp. 2016, 2022
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'jquery'
], function(
	$
) {
	'use strict';
	var REQUIRED_PERMISSIONS = ['read', 'execute', 'write'];

	class RefreshDataSourceAction {

		constructor() {}

		// Called by Glass when actionController is created.
		initialize(context) {
			return context.glassContext.getSvc('.DatasetExecutionService').then((datasetExecutionService) => {
				this.datasetExecutionService = datasetExecutionService;
			});
		}

		/**
		 * Determine when we show/hide the menu item
		 */
		isItemVisible(options) {
			var objectInfo = this._getObjectInfo(options);

			if (!objectInfo) {
				return false;
			}

			if (objectInfo.type !== 'dataSet2') {
				return false;
			}

			var permissions = objectInfo.permissions;
			for (var i = 0; i < REQUIRED_PERMISSIONS.length; i = i + 1) {
				if ($.inArray(REQUIRED_PERMISSIONS[i], permissions) === -1) {
					return false;
				}
			}

			return !this.datasetExecutionService.isExecuting(objectInfo.id);
		}

		/**
		 * Default action handler
		 */
		onSelectItem(options) {
			var objectInfo = this._getObjectInfo(options);
			if (!objectInfo) {
				return;
			}

			this.datasetExecutionService.execute({
				'id': objectInfo.id,
				'name': objectInfo.defaultName,
				'glassContext': options.glassContext,
				'isRefresh': true
			});

			var dataSource;
			if (options && options.target && options.target.activeObject && options.target.activeObject) {

				var activeObj = options.target.activeObject;
				if (activeObj.dataSource) {
					dataSource = options.target.activeObject.dataSource;
				} else if (activeObj.parentSlideout) {
					dataSource = options.target.activeObject.parentSlideout.dataSource;
				}
			}
			return this.datasetExecutionService.whenComplete(objectInfo.id).then(() => {
				if (dataSource) {
					dataSource.reloadMetadata();
					dataSource.setState('ready');
				}
			}).catch((err) => {
				if ( options && options.glassContext ) {
					options.glassContext.getCoreSvc('.Logger').error(err);
				}
				if (dataSource) {
					dataSource.setState('error');
				}
			});
		}

		_getObjectInfo(options) {
			if (options && options.target && options.target.activeObject) {
				var aSelectedContext = options.target.activeObject.aSelectedContext;
				if (aSelectedContext.length === 1) {
					return aSelectedContext[0];
				}
			}

			return null;
		}
	}

	return RefreshDataSourceAction;
});
